import {
  Button,
  TextInput,
  Label,
  SelectInput,
  Unform,
  AddObservation,
  CheckboxComp,
} from 'components';
import { BodyProps } from 'constants/MultipleAcorddions';
import React, { memo, useCallback, useContext, useEffect, useMemo, useRef } from 'react';
import { Flex, Box, Stack } from '@chakra-ui/react';
import { FormHandles, SubmitHandler } from '@unform/core';
import { getCommonProps } from 'utils/CommonPropperties';
import { checkPermission } from 'utils/authentication';

import { evaluationCtx } from '../../index';
import Evaluation from 'models/Forms/Evaluation';

interface IProps extends BodyProps {}
const PurposesComponent: React.FC<IProps> = ({ index, functionCallback, submit, completed }) => {
  const ctx = useContext(evaluationCtx);
  const { load, setIsLoad } = useContext(evaluationCtx);
  const [loading, setLoading] = React.useState<boolean>(false);
  const formRef = useRef<FormHandles>(null);

  const [boxes, setBoxes] = React.useState<string[]>(
    (ctx.data.legalBaseDataSources || 'Nenhuma das anteriores').split(/,(?!\s)/g),
  );

  const checkboxes = [
    'A pessoa deu o consentimento para o uso de seus dados',
    'O uso dos dados é necessário para cumprir obrigação legal aplicável à nossa empresa',
    'O uso dos dados é necessário para atingir os interesses de nossa empresa no curso de nossos negócios',
    'O uso dos dados é necessário para assegurar direitos da nossa empresa em processos judiciais, administrativos ou arbitrais',
    'O uso dos dados é necessário para a proteção do crédito',
    'O uso dos dados é necessário para tutelar a saúde da pessoa a quem se referem',
    'O uso dos dados é necessário para a proteção da vida ou integridade física de alguém',
    'Tenho dúvidas',
    'O uso dos dados é necessário para a execução de um contrato que ela firmou ou firmará',
    'Nenhuma das anteriores',
  ];

  useEffect(() => {
    ctx.handlePayload(prevState => ({
      ...prevState,
      legalBaseDataSources: boxes.toString(),
    }));

    if (boxes.length === 0 || boxes.includes('Nenhuma das anteriores')) {
      formRef.current?.setFieldValue('legalBase', 'Não');
    } else {
      formRef.current?.setFieldValue('legalBase', 'Sim');
    }
  }, [boxes]);

  function boxClicked(box: string) {
    if (box === 'Nenhuma das anteriores' || (boxes.length === 1 && boxes.includes(box))) {
      return setBoxes(['Nenhuma das anteriores']);
    } else {
      return setBoxes(bx => {
        const arr = [...bx].filter(i => i !== 'Nenhuma das anteriores');
        const index = arr.indexOf(box);
        if (index > -1) arr.splice(index, 1);
        else arr.push(box);
        return arr;
      });
    }
  }

  const handleSubmit = useCallback<SubmitHandler<Evaluation>>(
    async data => {
      setLoading(true);
      if (submit) {
        setIsLoad(!load);
        const resp = await submit(data, '3 - Propósitos');
        if (resp) {
          functionCallback(index + 1);
        }
      } else {
        functionCallback(index + 1);
      }
      setLoading(false);
    },
    [functionCallback, submit],
  );

  const commonProps = useMemo(
    () => ({ ...getCommonProps(!!ctx.isDetails), defaultBgColor: 'primary' }),
    [ctx.isDetails],
  );

  return (
    <Flex marginTop="1rem" width="100%" direction="column">
      <Unform
        formRef={formRef}
        initialData={ctx.data}
        onSubmit={handleSubmit}
        // validationSchema={purposesValidationSchema}
      >
        {checkPermission({ onlyAdmin: true }) ? (
          <>
            <Label>O projeto envolve o tratamento de alguma dessas categorias de dados?</Label>
            <Flex flexDirection="column" mt="23px">
              {checkboxes.map((value, index) => (
                <CheckboxComp
                  // {...commonProps}
                  onChange={() => boxClicked(value)}
                  isChecked={boxes.includes(value)}
                  key={index}
                >
                  {value}
                </CheckboxComp>
              ))}
            </Flex>
            <Box>
              <div style={{ visibility: 'hidden' }}>
                <TextInput {...commonProps} disabled={true} defaultValue={'Não'} name="legalBase" />
              </div>
              <AddObservation
                // isDetail={!ctx.isDetails}
                placeholder={'Observações (opcional)'}
                marginTop="0px"
                marginBottom="30px"
                onChangeEvent={e =>
                  ctx.handlePayload(prevState => ({
                    ...prevState,
                    jsonCustomObsObj: { ...prevState.jsonCustomObsObj, legalBase: e.target.value },
                  }))
                }
                obsValue={ctx.data.jsonCustomObsObj.legalBase}
              />
            </Box>
            <Box>
              <SelectInput
                label="Os propósitos do projeto são claros e informados às pessoas cujos dados são utilizados/tratados?"
                name="projectPurposesAreClear"
                placeholder="Selecione"
                mt="20px"
                mb="10px"
                options={[
                  { label: 'Sim', value: 'yes' },
                  { label: 'Não', value: 'no' },
                ]}
                // {...commonProps}
              />
              <AddObservation
                placeholder={'Observações (opcional)'}
                marginTop="0px"
                marginBottom="30px"
                onChangeEvent={e =>
                  ctx.handlePayload(prevState => ({
                    ...prevState,
                    jsonCustomObsObj: {
                      ...prevState.jsonCustomObsObj,
                      projectPurposesAreClear: e.target.value,
                    },
                  }))
                }
                obsValue={ctx.data.jsonCustomObsObj.projectPurposesAreClear}
              />
            </Box>
            <Box>
              <SelectInput
                label="Os dados pessoais coletados para o projeto serão utilizados para outros propósitos e/ou por outra área?"
                name="projectWillBeUsedForOtherPurposes"
                placeholder="Selecione"
                mt="20px"
                mb="10px"
                options={[
                  { label: 'Sim', value: 'yes' },
                  { label: 'Não', value: 'no' },
                ]}
                // {...commonProps}
              />
              <AddObservation
                placeholder={'Observações (opcional)'}
                marginTop="0px"
                marginBottom="30px"
                onChangeEvent={e =>
                  ctx.handlePayload(prevState => ({
                    ...prevState,
                    jsonCustomObsObj: {
                      ...prevState.jsonCustomObsObj,
                      projectWillBeUsedForOtherPurposes: e.target.value,
                    },
                  }))
                }
                obsValue={ctx.data.jsonCustomObsObj.projectWillBeUsedForOtherPurposes}
              />
            </Box>
            <Box>
              <SelectInput
                label="Os dados pessoais coletados serão utilizados para criação de perfis ou dossiês de indivíduos, como perfil de compra, de trajetos, familiar, etc?"
                name="creationOfProfilesOfIndividuals"
                placeholder="Selecione"
                mt="20px"
                mb="10px"
                options={[
                  { label: 'Sim', value: 'yes' },
                  { label: 'Não', value: 'no' },
                ]}
                // {...commonProps}
              />
              <AddObservation
                placeholder={'Observações (opcional)'}
                marginTop="0px"
                marginBottom="30px"
                onChangeEvent={e =>
                  ctx.handlePayload(prevState => ({
                    ...prevState,
                    jsonCustomObsObj: {
                      ...prevState.jsonCustomObsObj,
                      creationOfProfilesOfIndividuals: e.target.value,
                    },
                  }))
                }
                obsValue={ctx.data.jsonCustomObsObj.creationOfProfilesOfIndividuals}
              />
            </Box>
            {!ctx.isDetails && (
              <Box width="100%">
                <Stack direction={['column', 'row']} spacing="1rem" mt="1rem" justify="flex-end">
                  <Button
                    type="button"
                    variant="primary"
                    outline
                    onClick={() => functionCallback(index - 1)}
                  >
                    Voltar
                  </Button>
                  <Button variant="primary" type="submit" isLoading={loading} disabled={loading}>
                    Próximo
                  </Button>
                </Stack>
              </Box>
            )}
            {ctx.isDetails && (
              <Box width="100%">
                <Stack direction={['column', 'row']} spacing="1rem" mt="1rem" justify="flex-end">
                  <Button
                    type="button"
                    variant="primary"
                    outline
                    onClick={() => functionCallback(index - 1)}
                  >
                    Voltar
                  </Button>
                  <Button variant="primary" type="submit" isLoading={loading} disabled={loading}>
                    Próximo
                  </Button>
                </Stack>
              </Box>
            )}
          </>
        ) : (
          <>
            <Label>O projeto envolve o tratamento de alguma dessas categorias de dados?</Label>
            <Flex flexDirection="column" mt="23px">
              {checkboxes.map((value, index) => (
                <CheckboxComp
                  isDisabled={completed}
                  onChange={() => boxClicked(value)}
                  isChecked={boxes.includes(value)}
                  key={index}
                >
                  {value}
                </CheckboxComp>
              ))}
            </Flex>
            <Box>
              <div style={{ visibility: 'hidden' }}>
                <TextInput
                  isDisabled={completed}
                  disabled={true}
                  defaultValue={'Não'}
                  name="legalBase"
                />
              </div>
              <AddObservation
                isDetail={completed}
                placeholder={'Observações (opcional)'}
                marginTop="0px"
                marginBottom="30px"
                onChangeEvent={e =>
                  ctx.handlePayload(prevState => ({
                    ...prevState,
                    jsonCustomObsObj: { ...prevState.jsonCustomObsObj, legalBase: e.target.value },
                  }))
                }
                obsValue={ctx.data.jsonCustomObsObj.legalBase}
              />
            </Box>
            <Box>
              <SelectInput
                label="Os propósitos do projeto são claros e informados às pessoas cujos dados são utilizados/tratados?"
                name="projectPurposesAreClear"
                placeholder="Selecione"
                mt="20px"
                mb="10px"
                options={[
                  { label: 'Sim', value: 'yes' },
                  { label: 'Não', value: 'no' },
                ]}
                isDisabled={completed}
              />
              <AddObservation
                isDetail={completed}
                placeholder={'Observações (opcional)'}
                marginTop="0px"
                marginBottom="30px"
                onChangeEvent={e =>
                  ctx.handlePayload(prevState => ({
                    ...prevState,
                    jsonCustomObsObj: {
                      ...prevState.jsonCustomObsObj,
                      projectPurposesAreClear: e.target.value,
                    },
                  }))
                }
                obsValue={ctx.data.jsonCustomObsObj.projectPurposesAreClear}
              />
            </Box>
            <Box>
              <SelectInput
                label="Os dados pessoais coletados para o projeto serão utilizados para outros propósitos e/ou por outra área?"
                name="projectWillBeUsedForOtherPurposes"
                placeholder="Selecione"
                mt="20px"
                mb="10px"
                options={[
                  { label: 'Sim', value: 'yes' },
                  { label: 'Não', value: 'no' },
                ]}
                isDisabled={completed}
              />
              <AddObservation
                isDetail={completed}
                placeholder={'Observações (opcional)'}
                marginTop="0px"
                marginBottom="30px"
                onChangeEvent={e =>
                  ctx.handlePayload(prevState => ({
                    ...prevState,
                    jsonCustomObsObj: {
                      ...prevState.jsonCustomObsObj,
                      projectWillBeUsedForOtherPurposes: e.target.value,
                    },
                  }))
                }
                obsValue={ctx.data.jsonCustomObsObj.projectWillBeUsedForOtherPurposes}
              />
            </Box>
            <Box>
              <SelectInput
                label="Os dados pessoais coletados serão utilizados para criação de perfis ou dossiês de indivíduos, como perfil de compra, de trajetos, familiar, etc?"
                name="creationOfProfilesOfIndividuals"
                placeholder="Selecione"
                mt="20px"
                mb="10px"
                options={[
                  { label: 'Sim', value: 'yes' },
                  { label: 'Não', value: 'no' },
                ]}
                isDisabled={completed}
              />
              <AddObservation
                isDetail={completed}
                placeholder={'Observações (opcional)'}
                marginTop="0px"
                marginBottom="30px"
                onChangeEvent={e =>
                  ctx.handlePayload(prevState => ({
                    ...prevState,
                    jsonCustomObsObj: {
                      ...prevState.jsonCustomObsObj,
                      creationOfProfilesOfIndividuals: e.target.value,
                    },
                  }))
                }
                obsValue={ctx.data.jsonCustomObsObj.creationOfProfilesOfIndividuals}
              />
            </Box>
            {!completed && (
              <Box width="100%">
                <Stack direction={['column', 'row']} spacing="1rem" mt="1rem" justify="flex-end">
                  <Button
                    type="button"
                    variant="primary"
                    outline
                    onClick={() => functionCallback(index - 1)}
                  >
                    Voltar
                  </Button>
                  <Button variant="primary" type="submit" isLoading={loading} disabled={loading}>
                    Próximo
                  </Button>
                </Stack>
              </Box>
            )}
          </>
        )}
      </Unform>
    </Flex>
  );
};

export const Purposes = memo(PurposesComponent);
